import {
  BOOK_APPOINTMENT_REQUEST,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_FAIL,
  BOOK_APPOINTMENT_RESET,
  GET_APPOINTMENT_REQUEST,
  GET_APPOINTMENT_SUCCESS,
  GET_APPOINTMENT_FAIL,
  GET_DOCTORS_FAIL,
  GET_DOCTORS_REQUEST,
  GET_DOCTORS_RESET,
  GET_DOCTORS_SUCCESS,
  GET_CLINICS_FAIL,
  GET_CLINICS_REQUEST,
  GET_CLINICS_RESET,
  GET_CLINICS_SUCCESS,
} from "../constants/appointmentConstants.js";

import AppointmentService from "../../services/appointmentService.js";
import { toast } from "../../utils/toast";

/**
 * Book appointment action
 * @param {Object} request - Appointment booking request data
 */
const bookAppointmentAction = (request) => async (dispatch) => {
  try {
    dispatch({
      type: BOOK_APPOINTMENT_REQUEST,
    });

    const data = await AppointmentService.bookAppointment(request);

    dispatch({
      type: BOOK_APPOINTMENT_SUCCESS,
      payload: data,
    });

    toast.success('Appointment booked successfully!');
    
  } catch (error) {
    console.error('Book appointment error:', error);
    
    const errorMessage = error.response?.data?.message || error.message || 'Failed to book appointment';
    
    dispatch({
      type: BOOK_APPOINTMENT_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

/**
 * Get appointments action
 * @param {string|number} patient - Patient ID
 */
const getAppointmentAction = (patient) => async (dispatch) => {
  try {
    dispatch({
      type: GET_APPOINTMENT_REQUEST,
    });

    const data = await AppointmentService.getAppointments(patient);

    dispatch({
      type: GET_APPOINTMENT_SUCCESS,
      payload: data,
    });
    
  } catch (error) {
    console.error('Get appointments error:', error);
    
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch appointments';
    
    dispatch({
      type: GET_APPOINTMENT_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

/**
 * Get doctors action
 */
const getDoctorsAction = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_DOCTORS_REQUEST,
    });

    const data = await AppointmentService.getDoctors();

    dispatch({
      type: GET_DOCTORS_SUCCESS,
      payload: data,
    });
    
  } catch (error) {
    console.error('Get doctors error:', error);
    
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch doctors';
    
    dispatch({
      type: GET_DOCTORS_FAIL,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

/**
 * Get clinics action
 */
const getClinicsAction = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_CLINICS_REQUEST,
    });

    const data = await AppointmentService.getClinics();

    dispatch({
      type: GET_CLINICS_SUCCESS,
      payload: data,
    });
    
  } catch (error) {
    console.error('Get clinics error:', error);
    
    let errorMessage = 'Failed to fetch clinics';
    
    // Let axios interceptor handle 401 errors globally
    if (error?.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    dispatch({
      type: GET_CLINICS_FAIL,
      payload: errorMessage,
    });

    // Only show toast for non-auth errors to avoid spam
    if (error?.response?.status !== 401) {
      toast.error(errorMessage);
    }
  }
};

export { bookAppointmentAction, getAppointmentAction, getDoctorsAction, getClinicsAction };
